module.exports = __webpack_public_path__ + "static/media/add-existing-registry-banner.cab2144e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/add-existing-registry-banner.gif
// module id = 1297
// module chunks = 44